import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideRouter, RouterModule } from '@angular/router';

import { DefaultLayoutComponent } from './default-layout.component';
import { defaultLayoutRoutes } from './default-layout.routes';

import { CmsRenderLazyComponent } from '@features/cms-render';
import { InViewportDirective } from '@layout/ui/directives/inviewport.directive';
import { OffsetBodyDirective } from '@layout/ui/directives/offset-body.directive';
import { ABTestingModule } from '@shared/ab-testing/AB-testing.module';
import { HeaderSearchComponent } from '@shared/header/components/header-search/header-search.component';
import { HeaderModule } from '@shared/header/header.module';
import { HeaderMenuModule } from '@shared/header-menu/header-menu.module';
import { TopNotificationComponent } from '@shared/top-notification/top-notification.component';

@NgModule({
    declarations: [
        DefaultLayoutComponent,
    ],
    imports: [
        ABTestingModule,
        CmsRenderLazyComponent,
        CommonModule,
        HeaderMenuModule,
        HeaderModule,
        HeaderSearchComponent,
        InViewportDirective,
        OffsetBodyDirective,
        RouterModule,
        TopNotificationComponent,
    ],
    exports: [
        DefaultLayoutComponent,
    ],
    providers: [
        provideRouter(defaultLayoutRoutes),
    ],
})

/**
 * Default layout module
 */
export class DefaultLayoutModule {

}
